/**
 * SweetAlert를 사용하지 않고 기본 alert로 메시지를 표시합니다.
 * 실제 프로젝트에서는 SweetAlert2와 같은 라이브러리를 사용할 수 있습니다.
 * @param {string} message - 표시할 메시지
 * @param {string} type - 알림 유형 (info, success, warning, error)
 */
export const swalAlert = (message, type = 'info') => {
  // 실제 SweetAlert 라이브러리가 있다면 그것을 사용할 수 있음
  // 현재는 간단한 alert로 대체
  const typeEmoji = {
    'info': 'ℹ️',
    'success': '✅',
    'warning': '⚠️',
    'error': '❌'
  };
  
  const emoji = typeEmoji[type] || typeEmoji.info;
  alert(`${emoji} ${message}`);
}; 